import * as fwConfig from './foodwasteConfig';
import * as salesConfig from './salesConfig';
import * as benchmarkConfig from './benchmarkConfig';
import { AdvancedReportType, isBenchmarkReport } from 'pages/Report/Advanced';

export function createConfig(type: AdvancedReportType) {
  if (isBenchmarkReport(type)) {
    return benchmarkConfig;
  }
  if (type === AdvancedReportType.foodwaste) {
    return fwConfig;
  }
  return salesConfig;
}
